/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  SpacesSummariesControllerSpacesSummariesV1200,
  SpacesSummariesControllerSpacesSummariesV1Params,
  SpacesSummariesControllerSpacesSummariesV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class SpaceSummariesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve space summaries for a given location
   */

  spacesSummaries<TData = SpacesSummariesControllerSpacesSummariesV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId }: SpacesSummariesControllerSpacesSummariesV1PathParameters,
    params?: SpacesSummariesControllerSpacesSummariesV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces-summaries`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
